import ProductInfoVideo from '../components/ProductInfoVideo';

$(document).ready(function () {
    $('body').on('product:afterAttributeSelect', function (
    e,
    { data, container }
  ) {
        const $productContainer = container;

        if (data.product.watchVideoID && data.product.watchVideoID !== 'no-video') {
            var renderVariantVideo =
        '<!-- VariantVideo -->' +
        '<div id="info-video-container" class="product-info-video " data-embed-code="<iframe width=&quot;560&quot; height=&quot;315&quot; src=&quot;https://www.youtube-nocookie.com/embed/' + data.product.watchVideoID + '&quot; frameborder=&quot;0&quot; allow=&quot;accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture&quot; allowfullscreen></iframe>">' +
        '<div id="info-video-modal" class="modal " data-options="{&quot;triggerModalOpenSelector&quot;:&quot;#btn-open-info-vid&quot;}">' +
        '<div class="modal__box">' +
        '<button class="modal__close" title="Modal Close">' +
        '<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M14.54544.7071l.74741.7474-6.54599 6.54445 6.54605 6.5465-.74747.74745-6.54649-6.54604-6.54445 6.546-.74741-.74742L7.25208 8 .70709 1.45456 1.45456.7071 8 7.25208 14.54544.7071z" stroke="currentColor" fill="none" fill-rule="evenodd"/>' +
        '</svg>' +
        '</button>' +
        '<div class="modal__content"><div class="product-info-video__error-message"><h3>There was a problem loading the video</h3></div></div>' +
        '</div>' +
        '<div class="modal__overlay"></div>' +
        '</div>' +
        '</div>';
            $productContainer.find('.watchvideo').empty().html(renderVariantVideo);
            $productContainer.find('#btn-open-info-vid').attr('style', 'display:block');
            new ProductInfoVideo('info-video-container'); // eslint-disable-line no-new
        } else {
            $productContainer.find('.watchvideo').empty();
            $productContainer.find('#btn-open-info-vid').attr('style', 'display:none');
        }
    });
});

